import * as yup from 'yup';

export const addChargesFormSchema = yup.object().shape({
  chargeDescription: yup.string().required(),
  applicableOrderTypes: yup
    .array()
    .nullable()
    .default([])
    .min(1)
    .of(yup.string()),
  chargeType: yup.string().oneOf(['AMOUNT', 'PERCENTAGE']).default('AMOUNT'),
  extChargeId: yup.string().default('').nullable(),
  enabledDynamicDelivery: yup.boolean().required().default(false),
  taxable: yup.boolean().required().default(false),
  enabledChargeRules: yup.boolean().required().default(false),
  amount: yup
    .number()
    .flexDefault(0)
    .when('chargeType', {
      is: val => val === 'AMOUNT',
      then: schema => schema.required(),
    }),
  percentage: yup
    .number()
    .flexDefault(0)
    .max(100)
    .min(0)
    .when('chargeType', {
      is: val => val === 'PERCENTAGE',
      then: schema => schema.required(),
    }),
  rules: yup.array().of(
    yup.object({
      amount: yup.number().required().flexDefault(0),
      operator: yup.string().required().default(''),
    }),
  ),
  dynamicDelivery: yup
    .array()
    .of(
      yup
        .object({
          amount: yup.number().required().flexDefault(0),
          percentage: yup.number().flexDefault(0).max(100).min(0),
          extChargeId: yup.string().nullable(),
          minDistance: yup.string(),
        })
        .default({}),
    )
    .default([
      {
        amount: 0,
        extChargeId: '',
        minDistance: 0,
        percentage: 0,
      },
    ]),
  taxes: yup.array().of(
    yup.object({
      taxType: yup.mixed().oneOf(['AMOUNT', 'PERCENTAGE']).default('AMOUNT'),
      taxDescription: yup.string().default(''),
      amount: yup
        .number()
        .flexDefault(0)
        .when('taxType', {
          is: val => val === 'AMOUNT',
          then: schema => schema.required(),
        }),
      percentage: yup
        .number()
        .flexDefault(0)
        .max(100)
        .min(0)
        .when('taxType', {
          is: val => val === 'PERCENTAGE',
          then: schema => schema.required(),
        }),
      extTaxId: yup.string().nullable().default(''),
    }),
  ),
});
